/**
 * Normalize path trigger values to string[].
 * API/legacy may return a single string or non-array; safe for validation and display.
 */
export function normalizeTriggerValues(values: unknown): string[] {
  if (Array.isArray(values)) return [...values].filter((v): v is string => typeof v === 'string');
  if (typeof values === 'string') return [values];
  return [];
}
